import { Navigate, Route, Routes } from "react-router-dom";

import { AppLayout } from "@/components/Layout/AppLayout";
import { AdminTenantsPage } from "@/pages/AdminTenantsPage";
import { AdminUsersPage } from "@/pages/AdminUsersPage";
import { AuditPage } from "@/pages/AuditPage";
import { BessPage } from "@/pages/BessPage";
import { ClientsPage } from "@/pages/ClientsPage";
import { DataPage } from "@/pages/DataPage";
import { FinancePage } from "@/pages/FinancePage";
import { HeatMetersPage } from "@/pages/HeatMetersPage";
import { HomePage1 } from "@/pages/HomePage1";
import { HomePage2 } from "@/pages/HomePage2";
import { ImportExportPage } from "@/pages/ImportExportPage";
import { MonthlyPage } from "@/pages/MonthlyPage";
import { KguSettingsPage } from "@/pages/KguSettingsPage";
import { LoginPage } from "@/pages/LoginPage";
import { NotificationsPage } from "@/pages/NotificationsPage";
import { OptimizerPage } from "@/pages/OptimizerPage";
import { OtpPage } from "@/pages/OtpPage";
import { PeriodsPage } from "@/pages/PeriodsPage";
import { PlaceholderPage } from "@/pages/PlaceholderPage";
import { PlanPage } from "@/pages/PlanPage";
import { RdnPage } from "@/pages/RdnPage";
import { SessionPage } from "@/pages/SessionPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { SourcesPage } from "@/pages/SourcesPage";
import { StatisticsPage } from "@/pages/StatisticsPage";
import { ProtectedRoute } from "@/routes/ProtectedRoute";
import { MENU_SECTIONS } from "@/lib/menu";

// Шляхи, для яких ми вже маємо реальні сторінки.
// Інші пункти меню рендеряться через <PlaceholderPage>.
const REAL_ROUTES: Record<string, React.ComponentType> = {
  "/": HomePage1,
  "/home2": HomePage2,
  "/settings": SettingsPage,
  "/kgu-settings": KguSettingsPage,
  "/clients": ClientsPage,
  "/data": DataPage,
  "/schedule": PlanPage,
  "/optimizer": OptimizerPage,
  "/admin/periods": PeriodsPage,
  "/heat-meters": HeatMetersPage,
  "/notifications": NotificationsPage,
  "/admin/sources": SourcesPage,
  "/admin/users": AdminUsersPage,
  "/admin/tenants": AdminTenantsPage,
  "/admin/audit": AuditPage,
  "/finance": FinancePage,
  "/statistics": StatisticsPage,
  "/monthly": MonthlyPage,
  "/bess": BessPage,
  "/session": SessionPage,
  "/admin/import-export": ImportExportPage,
  "/rdn": RdnPage,
};

const allMenuItems = MENU_SECTIONS.flatMap((s) => s.items);

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/login/otp" element={<OtpPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          {allMenuItems.map((item) => {
            const RealPage = REAL_ROUTES[item.path];
            return (
              <Route
                key={item.path}
                path={item.path}
                element={
                  RealPage ? (
                    <RealPage />
                  ) : (
                    <PlaceholderPage titleKey={item.i18nKey} phase={item.phase} />
                  )
                }
              />
            );
          })}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
